import type { CoachingProfilePatch } from '@mlm/shared';
import type { CoachingProfile } from './api';

/** Birth details as edited in a form: strings for inputs, coordinates from the place search. */
export type BirthDraft = {
  birthDate: string;
  birthTime: string;
  birthTimeKnown: boolean;
  birthPlace: string;
  birthLat: number | null;
  birthLng: number | null;
};

export function birthDraftFrom(p: CoachingProfile): BirthDraft {
  return {
    birthDate: p.birthDate ?? '',
    birthTime: p.birthTime ?? '',
    birthTimeKnown: p.birthDate ? p.birthTimeKnown : true,
    birthPlace: p.birthPlace ?? '',
    birthLat: p.birthLat,
    birthLng: p.birthLng,
  };
}

/** Null when the draft is valid (including "no birth details at all"). */
export function birthDraftError(d: BirthDraft): string | null {
  if (!d.birthDate && d.birthLat === null) return null;
  if (!d.birthDate) return 'Enter your birth date, or clear the birth place.';
  if (d.birthLat === null || d.birthLng === null)
    return 'Search for your birth place and choose it from the list.';
  if (d.birthTimeKnown && !d.birthTime)
    return 'Enter your birth time, or tick that you do not know it.';
  return null;
}

export function birthPatch(d: BirthDraft): CoachingProfilePatch {
  const has = Boolean(d.birthDate);
  return {
    birthDate: has ? d.birthDate : null,
    birthTimeKnown: has ? d.birthTimeKnown : false,
    birthTime: has && d.birthTimeKnown ? d.birthTime : null,
    birthPlace: has ? d.birthPlace || null : null,
    birthLat: has ? d.birthLat : null,
    birthLng: has ? d.birthLng : null,
  };
}
